module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(6);
}, /* 1 */
, /* 2 */
, /* 3 */
, /* 4 */
, /* 5 */
, /* 6 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _Navigation = __webpack_require__(7);
    Object.defineProperty(exports, "default", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Navigation).default;
        }
    });
    var _ContainerItem = __webpack_require__(51);
    Object.defineProperty(exports, "AkContainerItem", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerItem).default;
        }
    });
    var _ContainerItemGroup = __webpack_require__(57);
    Object.defineProperty(exports, "AkContainerItemGroup", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerItemGroup).default;
        }
    });
    var _ContainerHeader = __webpack_require__(60);
    Object.defineProperty(exports, "AkContainerHeader", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerHeader).default;
        }
    });
    var _ContainerLogo = __webpack_require__(63);
    Object.defineProperty(exports, "AkContainerLogo", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerLogo).default;
        }
    });
    var _ContainerNavigation = __webpack_require__(38);
    Object.defineProperty(exports, "AkContainerNavigation", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerNavigation).default;
        }
    });
    var _ContainerNavigationNested = __webpack_require__(66);
    Object.defineProperty(exports, "AkContainerNavigationNested", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerNavigationNested).default;
        }
    });
    var _DrawerItem = __webpack_require__(69);
    Object.defineProperty(exports, "AkDrawerItem", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_DrawerItem).default;
        }
    });
    var _GlobalNavigation = __webpack_require__(19);
    Object.defineProperty(exports, "AkGlobalNavigation", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_GlobalNavigation).default;
        }
    });
    var _GlobalItem = __webpack_require__(31);
    Object.defineProperty(exports, "AkGlobalItem", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_GlobalItem).default;
        }
    });
}, /* 7 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _akBlanket = __webpack_require__(14), _akBlanket2 = _interopRequireDefault(_akBlanket), _Navigation = __webpack_require__(15), _Navigation2 = _interopRequireDefault(_Navigation), _GlobalNavigation = __webpack_require__(19), _GlobalNavigation2 = _interopRequireDefault(_GlobalNavigation), _ContainerNavigation = __webpack_require__(38), _ContainerNavigation2 = _interopRequireDefault(_ContainerNavigation), _DefaultLinkComponent = __webpack_require__(34), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _Drawer = __webpack_require__(41), _Drawer2 = _interopRequireDefault(_Drawer), _Resizer = __webpack_require__(47), _Resizer2 = _interopRequireDefault(_Resizer), _Spacer = __webpack_require__(25), _Spacer2 = _interopRequireDefault(_Spacer), _sharedVariables = __webpack_require__(24), _collapse = __webpack_require__(50), _collapse2 = _interopRequireDefault(_collapse), Navigation = function(_PureComponent) {
        function Navigation(props) {
            (0, _classCallCheck3.default)(this, Navigation);
            var _this = (0, _possibleConstructorReturn3.default)(this, (Navigation.__proto__ || (0, 
            _getPrototypeOf2.default)(Navigation)).call(this, props));
            return _this.onResize = function(resizeDelta) {
                _this.setState({
                    resizeDelta: resizeDelta
                });
            }, _this.getRenderedWidth = function() {
                var baselineWidth = _this.props.isOpen ? _this.props.width : _sharedVariables.containerClosedWidth, minWidth = _this.props.isCollapsible ? _sharedVariables.containerClosedWidth : _sharedVariables.navigationOpenWidth;
                return Math.max(minWidth, baselineWidth + _this.state.resizeDelta);
            }, _this.triggerResizeHandler = function() {
                var width = _this.getRenderedWidth(), resizeState = {
                    isOpen: width > _sharedVariables.resizeClosedBreakpoint
                };
                width > _sharedVariables.resizeExpandedBreakpoint && (resizeState.width = width), 
                _this.setState({
                    resizeDelta: 0
                }, function() {
                    this.props.onResize(resizeState);
                });
            }, _this.state = {
                resizeDelta: 0
            }, _this;
        }
        return (0, _inherits3.default)(Navigation, _PureComponent), (0, _createClass3.default)(Navigation, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, containerAppearance = _props.containerAppearance, containerHeader = _props.containerHeader, createDrawerContent = _props.createDrawerContent, drawerBackIcon = _props.drawerBackIcon, globalAccountItem = _props.globalAccountItem, globalCreateIcon = _props.globalCreateIcon, globalHelpItem = _props.globalHelpItem, globalPrimaryIcon = _props.globalPrimaryIcon, globalPrimaryItemHref = _props.globalPrimaryItemHref, globalSearchIcon = _props.globalSearchIcon, hasBlanket = _props.hasBlanket, isCreateDrawerOpen = _props.isCreateDrawerOpen, isOpen = _props.isOpen, isResizeable = _props.isResizeable, isSearchDrawerOpen = _props.isSearchDrawerOpen, linkComponent = _props.linkComponent, onBlanketClicked = _props.onBlanketClicked, onCreateDrawerClose = _props.onCreateDrawerClose, onCreateDrawerOpen = _props.onCreateDrawerOpen, onSearchDrawerClose = _props.onSearchDrawerClose, onSearchDrawerOpen = _props.onSearchDrawerOpen, searchDrawerContent = _props.searchDrawerContent, shouldAnimate = 0 === this.state.resizeDelta, renderedWidth = this.getRenderedWidth(), isPartiallyCollapsed = renderedWidth < _sharedVariables.globalOpenWidth + _sharedVariables.containerClosedWidth, onSearchDrawerTrigger = isSearchDrawerOpen ? onSearchDrawerClose : onSearchDrawerOpen, onCreateDrawerTrigger = isCreateDrawerOpen ? onCreateDrawerClose : onCreateDrawerOpen;
                return _react2.default.createElement("div", {
                    className: _Navigation2.default.navigation
                }, hasBlanket && (isSearchDrawerOpen || isCreateDrawerOpen) ? _react2.default.createElement(_akBlanket2.default, {
                    isTinted: !0,
                    onBlanketClicked: onBlanketClicked
                }) : null, _react2.default.createElement(_Spacer2.default, {
                    shouldAnimate: shouldAnimate,
                    width: renderedWidth
                }), _react2.default.createElement("div", {
                    className: _Navigation2.default.navigationInner
                }, _react2.default.createElement("div", {
                    style: {
                        zIndex: !isPartiallyCollapsed && 1
                    }
                }, _react2.default.createElement(_GlobalNavigation2.default, {
                    accountItem: globalAccountItem,
                    createIcon: globalCreateIcon,
                    helpItem: globalHelpItem,
                    linkComponent: linkComponent,
                    onCreateActivate: onCreateDrawerTrigger,
                    onSearchActivate: onSearchDrawerTrigger,
                    primaryIcon: globalPrimaryIcon,
                    primaryItemHref: globalPrimaryItemHref,
                    searchIcon: globalSearchIcon,
                    shouldAnimate: shouldAnimate
                })), _react2.default.createElement("div", {
                    style: {
                        zIndex: 2
                    }
                }, _react2.default.createElement(_Drawer2.default, {
                    backIcon: drawerBackIcon,
                    backIconPosition: "search",
                    header: containerHeader,
                    isOpen: isSearchDrawerOpen,
                    isWide: !0,
                    onBackButton: onSearchDrawerClose,
                    primaryIcon: globalPrimaryIcon
                }, searchDrawerContent), _react2.default.createElement(_Drawer2.default, {
                    backIcon: drawerBackIcon,
                    backIconPosition: "create",
                    header: containerHeader,
                    isOpen: isCreateDrawerOpen,
                    onBackButton: onCreateDrawerClose,
                    primaryIcon: globalPrimaryIcon
                }, createDrawerContent)), _react2.default.createElement("div", null, _react2.default.createElement(_ContainerNavigation2.default, {
                    appearance: containerAppearance,
                    areGlobalActionsVisible: !isOpen && this.state.resizeDelta <= 0,
                    globalCreateIcon: globalCreateIcon,
                    globalPrimaryIcon: globalPrimaryIcon,
                    globalPrimaryItemHref: globalPrimaryItemHref,
                    globalSearchIcon: globalSearchIcon,
                    header: containerHeader,
                    linkComponent: linkComponent,
                    offsetX: Math.min(renderedWidth - (_sharedVariables.globalOpenWidth + _sharedVariables.containerClosedWidth), 0),
                    onGlobalCreateActivate: onCreateDrawerTrigger,
                    onGlobalSearchActivate: onSearchDrawerTrigger,
                    shouldAnimate: shouldAnimate,
                    width: (0, _collapse2.default)(renderedWidth)
                }, children)), isResizeable ? _react2.default.createElement(_Resizer2.default, {
                    onResize: this.onResize,
                    onResizeEnd: this.triggerResizeHandler
                }) : null));
            }
        } ]), Navigation;
    }(_react.PureComponent);
    Navigation.propTypes = {
        children: _react.PropTypes.node,
        containerAppearance: _react.PropTypes.string,
        containerHeader: _react.PropTypes.node,
        createDrawerContent: _react.PropTypes.node,
        drawerBackIcon: _react.PropTypes.node,
        globalAccountItem: _react.PropTypes.node,
        globalCreateIcon: _react.PropTypes.node,
        globalHelpItem: _react.PropTypes.node,
        globalPrimaryIcon: _react.PropTypes.node,
        globalPrimaryItemHref: _react.PropTypes.string,
        globalSearchIcon: _react.PropTypes.node,
        hasBlanket: _react.PropTypes.bool,
        isCollapsible: _react.PropTypes.bool,
        isCreateDrawerOpen: _react.PropTypes.bool,
        isOpen: _react.PropTypes.bool,
        isResizeable: _react.PropTypes.bool,
        isSearchDrawerOpen: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onBlanketClicked: _react.PropTypes.func,
        onCreateDrawerClose: _react.PropTypes.func,
        onCreateDrawerOpen: _react.PropTypes.func,
        onResize: _react.PropTypes.func,
        onSearchDrawerClose: _react.PropTypes.func,
        onSearchDrawerOpen: _react.PropTypes.func,
        searchDrawerContent: _react.PropTypes.node,
        width: _react.PropTypes.number
    }, Navigation.defaultProps = {
        containerAppearance: "default",
        globalAccountDropdownComponent: function(_ref) {
            var children = _ref.children;
            return children;
        },
        globalHelpDropdownComponent: function(_ref2) {
            var children = _ref2.children;
            return children;
        },
        isCollapsible: !0,
        isCreateDrawerOpen: !1,
        isOpen: !0,
        isResizeable: !0,
        isSearchDrawerOpen: !1,
        linkComponent: _DefaultLinkComponent2.default,
        onBlanketClicked: function() {},
        onCreateDrawerClose: function() {},
        onCreateDrawerOpen: function() {},
        onResize: function() {},
        onSearchDrawerClose: function() {},
        onSearchDrawerOpen: function() {},
        width: _sharedVariables.navigationOpenWidth
    }, exports.default = Navigation;
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("ak-blanket");
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(16);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 16 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, ".yYVnQ06YhpDLqoJXpt9f7{height:100vh;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;z-index:2}.X3TnRe3MdOChX4MvlZR-C{top:0;left:0;height:100%;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;position:fixed;z-index:510}", "" ]), 
    // exports
    exports.locals = {
        navigation: "yYVnQ06YhpDLqoJXpt9f7",
        navigation: "yYVnQ06YhpDLqoJXpt9f7",
        navigationInner: "X3TnRe3MdOChX4MvlZR-C",
        navigationInner: "X3TnRe3MdOChX4MvlZR-C"
    };
}, /* 17 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 18 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 19 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _GlobalNavigation = __webpack_require__(22), _GlobalNavigation2 = _interopRequireDefault(_GlobalNavigation), _sharedVariables = __webpack_require__(24), _Spacer = __webpack_require__(25), _Spacer2 = _interopRequireDefault(_Spacer), _GlobalActions = __webpack_require__(28), _GlobalActions2 = _interopRequireDefault(_GlobalActions), _DefaultLinkComponent = __webpack_require__(34), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), GlobalNavigation = function(_PureComponent) {
        function GlobalNavigation() {
            return (0, _classCallCheck3.default)(this, GlobalNavigation), (0, _possibleConstructorReturn3.default)(this, (GlobalNavigation.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalNavigation)).apply(this, arguments));
        }
        return (0, _inherits3.default)(GlobalNavigation, _PureComponent), (0, _createClass3.default)(GlobalNavigation, [ {
            key: "render",
            value: function() {
                var _props = this.props, accountItem = _props.accountItem, createIcon = _props.createIcon, helpItem = _props.helpItem, linkComponent = _props.linkComponent, onCreateActivate = _props.onCreateActivate, onSearchActivate = _props.onSearchActivate, primaryIcon = _props.primaryIcon, primaryItemHref = _props.primaryItemHref, searchIcon = _props.searchIcon, shouldAnimate = _props.shouldAnimate;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _GlobalNavigation2.default.shouldAnimate, shouldAnimate))
                }, _react2.default.createElement(_Spacer2.default, {
                    shouldAnimate: shouldAnimate,
                    width: _sharedVariables.globalOpenWidth
                }), _react2.default.createElement("div", {
                    className: _GlobalNavigation2.default.globalNavigation
                }, _react2.default.createElement("div", {
                    className: _GlobalNavigation2.default.primaryContainer
                }, _react2.default.createElement(_GlobalActions2.default, {
                    createIcon: createIcon,
                    linkComponent: linkComponent,
                    onCreateActivate: onCreateActivate,
                    onSearchActivate: onSearchActivate,
                    primaryIcon: primaryIcon,
                    primaryItemHref: primaryItemHref,
                    searchIcon: searchIcon
                })), _react2.default.createElement("div", {
                    className: _GlobalNavigation2.default.secondaryContainer
                }, helpItem, accountItem)));
            }
        } ]), GlobalNavigation;
    }(_react.PureComponent);
    GlobalNavigation.propTypes = {
        accountItem: _react.PropTypes.node,
        helpItem: _react.PropTypes.node,
        linkComponent: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node,
        primaryItemHref: _react.PropTypes.string,
        shouldAnimate: _react.PropTypes.bool,
        searchIcon: _react.PropTypes.node,
        onSearchActivate: _react.PropTypes.func,
        onCreateActivate: _react.PropTypes.func,
        createIcon: _react.PropTypes.node
    }, GlobalNavigation.defaultProps = {
        accountItem: null,
        helpItem: null,
        linkComponent: _DefaultLinkComponent2.default,
        primaryIcon: null,
        shouldAnimate: !1
    }, exports.default = GlobalNavigation;
}, /* 20 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 21 */
/***/
function(module, exports) {
    module.exports = require("classnames");
}, /* 22 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(23);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 23 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._1exF4nbjn2V25n47OT6ONd{background:#0049b0;height:100%;width:64px;position:fixed;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:16px 0;padding-bottom:0;box-sizing:border-box}._1gDcIQAs5b2DD_smFgG3iy ._1exF4nbjn2V25n47OT6ONd{-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}._3hFThZ7oru45C6FsSl7gLC{margin-bottom:12px;margin-top:4px}.Kfxl-kVAwP_lvQJAhLb02{-webkit-box-flex:1;flex:1 1 auto}._2Kl24gz6S_Tvw0vvVeQTj1{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center;padding-bottom:20px}", "" ]), 
    // exports
    exports.locals = {
        globalNavigation: "_1exF4nbjn2V25n47OT6ONd",
        globalNavigation: "_1exF4nbjn2V25n47OT6ONd",
        shouldAnimate: "_1gDcIQAs5b2DD_smFgG3iy",
        shouldAnimate: "_1gDcIQAs5b2DD_smFgG3iy",
        primaryItem: "_3hFThZ7oru45C6FsSl7gLC",
        primaryItem: "_3hFThZ7oru45C6FsSl7gLC",
        primaryContainer: "Kfxl-kVAwP_lvQJAhLb02",
        primaryContainer: "Kfxl-kVAwP_lvQJAhLb02",
        secondaryContainer: "_2Kl24gz6S_Tvw0vvVeQTj1",
        secondaryContainer: "_2Kl24gz6S_Tvw0vvVeQTj1"
    };
}, /* 24 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    // NOTE: this is duplicated in shared-variables.less
    var globalOpenWidth = exports.globalOpenWidth = 64, containerOpenWidth = exports.containerOpenWidth = 220, containerClosedWidth = exports.containerClosedWidth = 64, navigationOpenWidth = exports.navigationOpenWidth = globalOpenWidth + containerOpenWidth;
    exports.resizeClosedBreakpoint = globalOpenWidth + containerOpenWidth / 2, exports.resizeExpandedBreakpoint = navigationOpenWidth + 50, 
    exports.collapseBreakpoint = globalOpenWidth + containerClosedWidth, exports.containerNavigationNestedPageSpacing = 8;
}, /* 25 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _Spacer = __webpack_require__(26), _Spacer2 = _interopRequireDefault(_Spacer), Spacer = function(_PureComponent) {
        function Spacer() {
            return (0, _classCallCheck3.default)(this, Spacer), (0, _possibleConstructorReturn3.default)(this, (Spacer.__proto__ || (0, 
            _getPrototypeOf2.default)(Spacer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Spacer, _PureComponent), (0, _createClass3.default)(Spacer, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Spacer2.default.spacer, (0, _defineProperty3.default)({}, _Spacer2.default.shouldAnimate, this.props.shouldAnimate)),
                    style: {
                        width: this.props.width
                    }
                });
            }
        } ]), Spacer;
    }(_react.PureComponent);
    Spacer.propTypes = {
        width: _react.PropTypes.number,
        shouldAnimate: _react.PropTypes.bool
    }, Spacer.defaultProps = {
        width: 0,
        shouldAnimate: !1
    }, exports.default = Spacer;
}, /* 26 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(27);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 27 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._3ZwCPwB7NpzNyB9F5dJ65V.aGGd2d-YFkniG6v3dJIiX{-webkit-transition:width .2s;transition:width .2s}", "" ]), 
    // exports
    exports.locals = {
        spacer: "_3ZwCPwB7NpzNyB9F5dJ65V",
        spacer: "_3ZwCPwB7NpzNyB9F5dJ65V",
        shouldAnimate: "aGGd2d-YFkniG6v3dJIiX",
        shouldAnimate: "aGGd2d-YFkniG6v3dJIiX"
    };
}, /* 28 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _GlobalActions = __webpack_require__(29), _GlobalActions2 = _interopRequireDefault(_GlobalActions), _GlobalItem = __webpack_require__(31), _GlobalItem2 = _interopRequireDefault(_GlobalItem), _DrawerTrigger = __webpack_require__(35), _DrawerTrigger2 = _interopRequireDefault(_DrawerTrigger), _DefaultLinkComponent = __webpack_require__(34), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), GlobalActions = function(_PureComponent) {
        function GlobalActions() {
            return (0, _classCallCheck3.default)(this, GlobalActions), (0, _possibleConstructorReturn3.default)(this, (GlobalActions.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalActions)).apply(this, arguments));
        }
        return (0, _inherits3.default)(GlobalActions, _PureComponent), (0, _createClass3.default)(GlobalActions, [ {
            key: "render",
            value: function() {
                var _props = this.props, appearance = _props.appearance, createIcon = _props.createIcon, isVisible = _props.isVisible, linkComponent = _props.linkComponent, onCreateActivate = _props.onCreateActivate, onSearchActivate = _props.onSearchActivate, primaryIcon = _props.primaryIcon, primaryItemHref = _props.primaryItemHref, searchIcon = _props.searchIcon;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_GlobalActions2.default.globalActions, (0, 
                    _defineProperty3.default)({}, _GlobalActions2.default.isVisible, isVisible))
                }, primaryIcon ? _react2.default.createElement("div", {
                    className: _GlobalActions2.default.primaryItem
                }, _react2.default.createElement(_GlobalItem2.default, {
                    appearance: appearance,
                    href: primaryItemHref,
                    linkComponent: linkComponent,
                    size: "medium"
                }, primaryIcon)) : null, _react2.default.createElement("div", {
                    className: _GlobalActions2.default.actions
                }, _react2.default.createElement(_DrawerTrigger2.default, {
                    onActivate: onSearchActivate
                }, _react2.default.createElement(_GlobalItem2.default, {
                    appearance: appearance,
                    size: "medium"
                }, searchIcon)), _react2.default.createElement(_DrawerTrigger2.default, {
                    onActivate: onCreateActivate
                }, _react2.default.createElement(_GlobalItem2.default, {
                    appearance: appearance,
                    size: "medium"
                }, createIcon))));
            }
        } ]), GlobalActions;
    }(_react.PureComponent);
    GlobalActions.propTypes = {
        appearance: _react.PropTypes.string,
        createIcon: _react.PropTypes.node,
        isVisible: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onCreateActivate: _react.PropTypes.func,
        onSearchActivate: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node,
        primaryItemHref: _react.PropTypes.string,
        searchIcon: _react.PropTypes.node
    }, GlobalActions.defaultProps = {
        isVisible: !0,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = GlobalActions;
}, /* 29 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(30);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 30 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._2aDTLwm-iVLLHRddN1Mf7B{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;margin-top:12px}._387bG0RjFOZJvCH-0zhgZc{box-sizing:border-box;height:0;opacity:0;visibility:hidden;-webkit-transition:height .22s,margin .22s,opacity .22s;transition:height .22s,margin .22s,opacity .22s}._387bG0RjFOZJvCH-0zhgZc ._2st1WwOAG1JRiwshd06vjd{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}._387bG0RjFOZJvCH-0zhgZc._15_3tps4foWY45L9hpiTgT{height:132px;margin-bottom:28px;opacity:1;visibility:visible}", "" ]), 
    // exports
    exports.locals = {
        actions: "_2aDTLwm-iVLLHRddN1Mf7B",
        actions: "_2aDTLwm-iVLLHRddN1Mf7B",
        globalActions: "_387bG0RjFOZJvCH-0zhgZc",
        globalActions: "_387bG0RjFOZJvCH-0zhgZc",
        primaryItem: "_2st1WwOAG1JRiwshd06vjd",
        primaryItem: "_2st1WwOAG1JRiwshd06vjd",
        isVisible: "_15_3tps4foWY45L9hpiTgT",
        isVisible: "_15_3tps4foWY45L9hpiTgT"
    };
}, /* 31 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _GlobalItem = __webpack_require__(32), _GlobalItem2 = _interopRequireDefault(_GlobalItem), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _DefaultLinkComponent = __webpack_require__(34), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), GlobalItem = function(_PureComponent) {
        function GlobalItem() {
            return (0, _classCallCheck3.default)(this, GlobalItem), (0, _possibleConstructorReturn3.default)(this, (GlobalItem.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalItem)).apply(this, arguments));
        }
        return (0, _inherits3.default)(GlobalItem, _PureComponent), (0, _createClass3.default)(GlobalItem, [ {
            key: "render",
            value: function() {
                var _classNames, _props = this.props, href = _props.href, Link = _props.linkComponent;
                return _react2.default.createElement(Link, {
                    href: href
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_GlobalItem2.default.globalItem, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.smallGlobalItem, "small" === this.props.size), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.mediumGlobalItem, "medium" === this.props.size), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.largeGlobalItem, "large" === this.props.size), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.isSelected, this.props.isSelected), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.hasContainerAppearance, "container" === this.props.appearance), 
                    _classNames))
                }, this.props.children));
            }
        } ]), GlobalItem;
    }(_react.PureComponent);
    GlobalItem.propTypes = {
        appearance: _react.PropTypes.oneOf([ "container", "global" ]),
        children: _react.PropTypes.node,
        href: _react.PropTypes.string,
        isSelected: _react.PropTypes.bool,
        size: _react.PropTypes.oneOf([ "small", "medium", "large" ]),
        linkComponent: _react.PropTypes.func
    }, GlobalItem.defaultProps = {
        appearance: "global",
        size: "small",
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = GlobalItem;
}, /* 32 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(33);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 33 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._6DPZ2TIXMkV4p7S28dnLk{-webkit-box-align:center;align-items:center;border-radius:50%;color:#fff;cursor:pointer;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}._6DPZ2TIXMkV4p7S28dnLk._1H5KJz54x0WFj0d1W2uvYd,._6DPZ2TIXMkV4p7S28dnLk:focus,._6DPZ2TIXMkV4p7S28dnLk:hover{background-color:rgba(9,30,66,.48)}._6DPZ2TIXMkV4p7S28dnLk:active{background-color:#2684ff}._3jVEk1rjOGL0TNZvkRFCXD{height:32px;margin-top:8px;width:32px}._3Vo0Ss907typg0hmeySxqz{height:40px;width:40px}._2zeX1APeBBw74vqJ7RJdmx{height:48px;width:48px}.akj7iJq4mbhP-nPOVvr__{color:#42526e}.akj7iJq4mbhP-nPOVvr__:hover{background-color:rgba(9,30,66,.04)}.akj7iJq4mbhP-nPOVvr__:active{color:#0049b0;background-color:#deebff}", "" ]), 
    // exports
    exports.locals = {
        globalItem: "_6DPZ2TIXMkV4p7S28dnLk",
        globalItem: "_6DPZ2TIXMkV4p7S28dnLk",
        isSelected: "_1H5KJz54x0WFj0d1W2uvYd",
        isSelected: "_1H5KJz54x0WFj0d1W2uvYd",
        smallGlobalItem: "_3jVEk1rjOGL0TNZvkRFCXD",
        smallGlobalItem: "_3jVEk1rjOGL0TNZvkRFCXD",
        mediumGlobalItem: "_3Vo0Ss907typg0hmeySxqz",
        mediumGlobalItem: "_3Vo0Ss907typg0hmeySxqz",
        largeGlobalItem: "_2zeX1APeBBw74vqJ7RJdmx",
        largeGlobalItem: "_2zeX1APeBBw74vqJ7RJdmx",
        hasContainerAppearance: "akj7iJq4mbhP-nPOVvr__",
        hasContainerAppearance: "akj7iJq4mbhP-nPOVvr__"
    };
}, /* 34 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), DefaultLinkComponent = function(_PureComponent) {
        function DefaultLinkComponent() {
            return (0, _classCallCheck3.default)(this, DefaultLinkComponent), (0, _possibleConstructorReturn3.default)(this, (DefaultLinkComponent.__proto__ || (0, 
            _getPrototypeOf2.default)(DefaultLinkComponent)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DefaultLinkComponent, _PureComponent), (0, _createClass3.default)(DefaultLinkComponent, [ {
            key: "render",
            value: function() {
                var _props = this.props, href = _props.href, children = _props.children, onMouseDown = _props.onMouseDown, className = _props.className;
                return href ? _react2.default.createElement("a", {
                    className: className,
                    href: href,
                    onMouseDown: onMouseDown
                }, children) : children;
            }
        } ]), DefaultLinkComponent;
    }(_react.PureComponent);
    DefaultLinkComponent.propTypes = {
        href: _react.PropTypes.string,
        children: _react.PropTypes.node,
        onMouseDown: _react.PropTypes.func,
        className: _react.PropTypes.string
    }, exports.default = DefaultLinkComponent;
}, /* 35 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _DrawerTrigger = __webpack_require__(36), _DrawerTrigger2 = _interopRequireDefault(_DrawerTrigger), DrawerTrigger = function(_PureComponent) {
        function DrawerTrigger() {
            return (0, _classCallCheck3.default)(this, DrawerTrigger), (0, _possibleConstructorReturn3.default)(this, (DrawerTrigger.__proto__ || (0, 
            _getPrototypeOf2.default)(DrawerTrigger)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DrawerTrigger, _PureComponent), (0, _createClass3.default)(DrawerTrigger, [ {
            key: "render",
            value: function() {
                return null === this.props.children ? null : _react2.default.createElement("button", {
                    "aria-haspopup": "true",
                    className: _DrawerTrigger2.default.drawerTrigger,
                    onClick: this.props.onActivate,
                    onMouseDown: function(e) {
                        return e.preventDefault();
                    }
                }, this.props.children);
            }
        } ]), DrawerTrigger;
    }(_react.PureComponent);
    DrawerTrigger.propTypes = {
        children: _react.PropTypes.node,
        onActivate: _react.PropTypes.func
    }, DrawerTrigger.defaultProps = {
        onActivate: function() {}
    }, exports.default = DrawerTrigger;
}, /* 36 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(37);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 37 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._3jYdkKzmmVa0p7PIOHlHtb{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;margin:0;background:none;border:none;border-radius:50%;padding:0;width:40px;height:40px;outline:none;color:#fff}._3jYdkKzmmVa0p7PIOHlHtb:focus{outline:none;box-shadow:0 0 0 2px #4c9aff}", "" ]), 
    // exports
    exports.locals = {
        drawerTrigger: "_3jYdkKzmmVa0p7PIOHlHtb",
        drawerTrigger: "_3jYdkKzmmVa0p7PIOHlHtb"
    };
}, /* 38 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _ContainerNavigation = __webpack_require__(39), _ContainerNavigation2 = _interopRequireDefault(_ContainerNavigation), _DefaultLinkComponent = __webpack_require__(34), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _GlobalActions = __webpack_require__(28), _GlobalActions2 = _interopRequireDefault(_GlobalActions), _sharedVariables = __webpack_require__(24), _Spacer = __webpack_require__(25), _Spacer2 = _interopRequireDefault(_Spacer), ContainerNavigation = function(_PureComponent) {
        function ContainerNavigation() {
            return (0, _classCallCheck3.default)(this, ContainerNavigation), (0, _possibleConstructorReturn3.default)(this, (ContainerNavigation.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerNavigation)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerNavigation, _PureComponent), (0, _createClass3.default)(ContainerNavigation, [ {
            key: "getOuterStyles",
            value: function() {
                return {
                    transform: "translateX(" + this.props.offsetX + "px)",
                    width: this.props.width
                };
            }
        }, {
            key: "render",
            value: function() {
                var _classNames2, _props = this.props, appearance = _props.appearance, areGlobalActionsVisible = _props.areGlobalActionsVisible, children = _props.children, globalCreateIcon = _props.globalCreateIcon, globalPrimaryIcon = _props.globalPrimaryIcon, globalPrimaryItemHref = _props.globalPrimaryItemHref, globalSearchIcon = _props.globalSearchIcon, header = _props.header, linkComponent = _props.linkComponent, offsetX = _props.offsetX, onGlobalCreateActivate = _props.onGlobalCreateActivate, onGlobalSearchActivate = _props.onGlobalSearchActivate, shouldAnimate = _props.shouldAnimate, width = _props.width, isWidthCollapsed = width <= _sharedVariables.containerClosedWidth;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _ContainerNavigation2.default.shouldAnimate, shouldAnimate)),
                    "data-__ak-navigation-container-closed": isWidthCollapsed
                }, _react2.default.createElement(_Spacer2.default, {
                    shouldAnimate: shouldAnimate,
                    width: width + offsetX
                }), _react2.default.createElement("div", {
                    className: _ContainerNavigation2.default.containerNavigationOuter,
                    style: this.getOuterStyles()
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_ContainerNavigation2.default.containerNavigationInner, (_classNames2 = {}, 
                    (0, _defineProperty3.default)(_classNames2, _ContainerNavigation2.default.hasContainerHeader, null !== header), 
                    (0, _defineProperty3.default)(_classNames2, _ContainerNavigation2.default.hasGlobalAppearance, "global" === appearance), 
                    _classNames2))
                }, _react2.default.createElement(_GlobalActions2.default, {
                    appearance: "global" === appearance ? "global" : "container",
                    createIcon: globalCreateIcon,
                    isVisible: areGlobalActionsVisible,
                    linkComponent: linkComponent,
                    onCreateActivate: onGlobalCreateActivate,
                    onSearchActivate: onGlobalSearchActivate,
                    primaryIcon: globalPrimaryIcon,
                    primaryItemHref: globalPrimaryItemHref,
                    searchIcon: globalSearchIcon
                }), _react2.default.createElement("div", null, header), _react2.default.createElement("div", null, children))));
            }
        } ]), ContainerNavigation;
    }(_react.PureComponent);
    ContainerNavigation.propTypes = {
        appearance: _react.PropTypes.string,
        areGlobalActionsVisible: _react.PropTypes.bool,
        children: _react.PropTypes.node,
        header: _react.PropTypes.node,
        shouldAnimate: _react.PropTypes.bool,
        width: _react.PropTypes.number,
        offsetX: _react.PropTypes.number,
        linkComponent: _react.PropTypes.func,
        globalPrimaryItemHref: _react.PropTypes.string,
        globalPrimaryIcon: _react.PropTypes.node,
        globalSearchIcon: _react.PropTypes.node,
        globalCreateIcon: _react.PropTypes.node,
        onGlobalCreateActivate: _react.PropTypes.func,
        onGlobalSearchActivate: _react.PropTypes.func
    }, ContainerNavigation.defaultProps = {
        appearance: "default",
        areGlobalActionsVisible: !1,
        shouldAnimate: !1,
        width: _sharedVariables.containerOpenWidth,
        offsetX: 0,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = ContainerNavigation;
}, /* 39 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(40);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 40 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, ".uQ82KpL0hPHhiceZ1ewNU{height:100%;position:fixed}._3tXZt7PoS-_ZqWmI_b-49t .uQ82KpL0hPHhiceZ1ewNU{-webkit-transition:width .2s,-webkit-transform .2s;transition:width .2s,-webkit-transform .2s;transition:width .2s,transform .2s;transition:width .2s,transform .2s,-webkit-transform .2s}._2Zbu06RJkQ1KSpRw16DXI8{box-sizing:border-box;background:#f4f5f7;color:#42526e;width:100%;height:100vh;overflow-x:hidden;overflow-y:auto;padding:16px 8px 0}._2Zbu06RJkQ1KSpRw16DXI8 a,._2Zbu06RJkQ1KSpRw16DXI8 a:hover,._2Zbu06RJkQ1KSpRw16DXI8 a:visited{color:inherit;text-decoration:none}._2Zbu06RJkQ1KSpRw16DXI8:not(.cmCVz9dRBjeZVI17kw7K8){padding-top:24px}._2Zbu06RJkQ1KSpRw16DXI8._2PfUNqskKFVfHroqauX6ku{background-color:#0049b0;color:#fff}", "" ]), 
    // exports
    exports.locals = {
        containerNavigationOuter: "uQ82KpL0hPHhiceZ1ewNU",
        containerNavigationOuter: "uQ82KpL0hPHhiceZ1ewNU",
        "should-animate": "_3tXZt7PoS-_ZqWmI_b-49t",
        shouldAnimate: "_3tXZt7PoS-_ZqWmI_b-49t",
        containerNavigationInner: "_2Zbu06RJkQ1KSpRw16DXI8",
        containerNavigationInner: "_2Zbu06RJkQ1KSpRw16DXI8",
        hasContainerHeader: "cmCVz9dRBjeZVI17kw7K8",
        hasContainerHeader: "cmCVz9dRBjeZVI17kw7K8",
        hasGlobalAppearance: "_2PfUNqskKFVfHroqauX6ku",
        hasGlobalAppearance: "_2PfUNqskKFVfHroqauX6ku"
    };
}, /* 41 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _Drawer = __webpack_require__(42), _Drawer2 = _interopRequireDefault(_Drawer), _DrawerTrigger = __webpack_require__(35), _DrawerTrigger2 = _interopRequireDefault(_DrawerTrigger), _DrawerBackIcon = __webpack_require__(44), _DrawerBackIcon2 = _interopRequireDefault(_DrawerBackIcon), Drawer = function(_PureComponent) {
        function Drawer() {
            return (0, _classCallCheck3.default)(this, Drawer), (0, _possibleConstructorReturn3.default)(this, (Drawer.__proto__ || (0, 
            _getPrototypeOf2.default)(Drawer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Drawer, _PureComponent), (0, _createClass3.default)(Drawer, [ {
            key: "render",
            value: function() {
                var _classNames, _props = this.props, backIcon = _props.backIcon, backIconPosition = _props.backIconPosition, header = _props.header, isOpen = _props.isOpen, isWide = _props.isWide, onBackButton = _props.onBackButton, primaryIcon = _props.primaryIcon;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.drawer, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _Drawer2.default.open, isOpen), (0, _defineProperty3.default)(_classNames, _Drawer2.default.wide, isWide), 
                    _classNames))
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.fixed, _Drawer2.default.side)
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.icon)
                }, primaryIcon), _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.backIconOuter, (0, _defineProperty3.default)({}, _Drawer2.default.isBackIconPositionCreate, "create" === backIconPosition))
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.backIcon)
                }, _react2.default.createElement(_DrawerTrigger2.default, {
                    onActivate: onBackButton
                }, _react2.default.createElement(_DrawerBackIcon2.default, {
                    isVisible: isOpen
                }, backIcon))))), _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.main)
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.fixed)
                }, header), _react2.default.createElement("div", null, this.props.children)));
            }
        } ]), Drawer;
    }(_react.PureComponent);
    Drawer.propTypes = {
        backIcon: _react.PropTypes.node,
        backIconPosition: _react.PropTypes.oneOf([ "search", "create" ]),
        children: _react.PropTypes.element,
        header: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        isWide: _react.PropTypes.bool,
        onBackButton: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node
    }, Drawer.defaultProps = {
        onBackButton: function() {},
        primaryIcon: null,
        isWide: !1,
        isOpen: !1
    }, exports.default = Drawer;
}, /* 42 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(43);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 43 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._3sUT9CQV2gUV_doVDWlqlP{display:none}._3k0fk1A_vBp7GF9Cf2UB2c{background:#fff;box-shadow:-32px 0 32px 32px rgba(23,43,77,.24);color:#42526e;display:-webkit-box;display:flex;height:100%;left:0;overflow:hidden;position:fixed;-webkit-transform:translateX(-392px);transform:translateX(-392px);-webkit-transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1),-webkit-transform .22s cubic-bezier(.15,1,.3,1);width:360px;z-index:510}._3k0fk1A_vBp7GF9Cf2UB2c:not(._2MT3xXgW8glJam42yjuCHT){box-shadow:none}._3k0fk1A_vBp7GF9Cf2UB2c._3ASK5fKOG9boxZrfy7CYdk{width:600px;-webkit-transform:translateX(-632px);transform:translateX(-632px)}._3k0fk1A_vBp7GF9Cf2UB2c._2MT3xXgW8glJam42yjuCHT,._3k0fk1A_vBp7GF9Cf2UB2c._3ASK5fKOG9boxZrfy7CYdk._2MT3xXgW8glJam42yjuCHT{-webkit-transform:translateX(0);transform:translateX(0)}._2O9n_OytDISSEfMoYTfb8U{-webkit-box-align:center;align-items:center;box-sizing:border-box;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:16px 0;width:64px}._2O9n_OytDISSEfMoYTfb8U ._10pMSnf2jew2qQ4rB936Nw{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;height:40px;-webkit-box-pack:center;justify-content:center;width:40px}._2O9n_OytDISSEfMoYTfb8U ._3O7Bfz631RiIbPVrHXz0_y{padding-top:40px}._2O9n_OytDISSEfMoYTfb8U ._2oRGV7vtxzJAWXhg9v6GIw{margin-top:12px}._1w9GPdbDj9fnD0oxaDFhaw{box-sizing:border-box;height:100%;overflow-y:auto;padding:16px 8px 0;width:calc(100% - 64px)}._3enSEjhiWo4vRsS0jrXvDW{-webkit-transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1),-webkit-transform .22s cubic-bezier(.15,1,.3,1);-webkit-transform:translateX(392px);transform:translateX(392px)}._3ASK5fKOG9boxZrfy7CYdk ._3enSEjhiWo4vRsS0jrXvDW{-webkit-transform:translateX(632px);transform:translateX(632px)}._2MT3xXgW8glJam42yjuCHT ._3enSEjhiWo4vRsS0jrXvDW,._3ASK5fKOG9boxZrfy7CYdk._2MT3xXgW8glJam42yjuCHT ._3enSEjhiWo4vRsS0jrXvDW{-webkit-transform:translateX(0);transform:translateX(0)}", "" ]), 
    // exports
    exports.locals = {
        hidden: "_3sUT9CQV2gUV_doVDWlqlP",
        hidden: "_3sUT9CQV2gUV_doVDWlqlP",
        drawer: "_3k0fk1A_vBp7GF9Cf2UB2c",
        drawer: "_3k0fk1A_vBp7GF9Cf2UB2c",
        open: "_2MT3xXgW8glJam42yjuCHT",
        open: "_2MT3xXgW8glJam42yjuCHT",
        wide: "_3ASK5fKOG9boxZrfy7CYdk",
        wide: "_3ASK5fKOG9boxZrfy7CYdk",
        side: "_2O9n_OytDISSEfMoYTfb8U",
        side: "_2O9n_OytDISSEfMoYTfb8U",
        icon: "_10pMSnf2jew2qQ4rB936Nw",
        icon: "_10pMSnf2jew2qQ4rB936Nw",
        isBackIconPositionCreate: "_3O7Bfz631RiIbPVrHXz0_y",
        isBackIconPositionCreate: "_3O7Bfz631RiIbPVrHXz0_y",
        backIconOuter: "_2oRGV7vtxzJAWXhg9v6GIw",
        backIconOuter: "_2oRGV7vtxzJAWXhg9v6GIw",
        main: "_1w9GPdbDj9fnD0oxaDFhaw",
        main: "_1w9GPdbDj9fnD0oxaDFhaw",
        fixed: "_3enSEjhiWo4vRsS0jrXvDW",
        fixed: "_3enSEjhiWo4vRsS0jrXvDW"
    };
}, /* 44 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _DrawerBackIcon = __webpack_require__(45), _DrawerBackIcon2 = _interopRequireDefault(_DrawerBackIcon), DrawerBackIcon = function(_PureComponent) {
        function DrawerBackIcon() {
            return (0, _classCallCheck3.default)(this, DrawerBackIcon), (0, _possibleConstructorReturn3.default)(this, (DrawerBackIcon.__proto__ || (0, 
            _getPrototypeOf2.default)(DrawerBackIcon)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DrawerBackIcon, _PureComponent), (0, _createClass3.default)(DrawerBackIcon, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, isVisible = _props.isVisible;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_DrawerBackIcon2.default.backIcon, (0, _defineProperty3.default)({}, _DrawerBackIcon2.default.isVisible, isVisible))
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_DrawerBackIcon2.default.icon)
                }, children));
            }
        } ]), DrawerBackIcon;
    }(_react.PureComponent);
    DrawerBackIcon.propTypes = {
        children: _react.PropTypes.node,
        isVisible: _react.PropTypes.bool
    }, DrawerBackIcon.defaultProps = {
        isVisible: !1
    }, exports.default = DrawerBackIcon;
}, /* 45 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(46);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 46 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, ".Y35RAKSL2A0q3WBOUboE{background:#f4f5f7;border-radius:50%;color:#42526e;cursor:pointer;display:-webkit-box;display:flex;height:40px;-webkit-box-pack:center;justify-content:center;width:40px}.Y35RAKSL2A0q3WBOUboE:active{background:#deebff;color:#0052cc}.Y35RAKSL2A0q3WBOUboE ._3j_3Bbs1RffNzZJ_sOex6R{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-transform:translatex(-16px);transform:translatex(-16px);-webkit-transition:-webkit-transform .22s;transition:-webkit-transform .22s;transition:transform .22s;transition:transform .22s,-webkit-transform .22s}.Y35RAKSL2A0q3WBOUboE._1dpkhmNNQD-XJgwZcwFd0I ._3j_3Bbs1RffNzZJ_sOex6R{-webkit-transform:translateX(0);transform:translateX(0)}", "" ]), 
    // exports
    exports.locals = {
        backIcon: "Y35RAKSL2A0q3WBOUboE",
        backIcon: "Y35RAKSL2A0q3WBOUboE",
        icon: "_3j_3Bbs1RffNzZJ_sOex6R",
        icon: "_3j_3Bbs1RffNzZJ_sOex6R",
        isVisible: "_1dpkhmNNQD-XJgwZcwFd0I",
        isVisible: "_1dpkhmNNQD-XJgwZcwFd0I"
    };
}, /* 47 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _Resizer = __webpack_require__(48), _Resizer2 = _interopRequireDefault(_Resizer), Resizer = function(_PureComponent) {
        function Resizer(props) {
            (0, _classCallCheck3.default)(this, Resizer);
            var _this = (0, _possibleConstructorReturn3.default)(this, (Resizer.__proto__ || (0, 
            _getPrototypeOf2.default)(Resizer)).call(this, props));
            return _this.mouseDownHandler = function(e) {
                _this.props.onResizeStart(), _this.setState({
                    startScreenX: e.screenX
                }), document.addEventListener("mousemove", _this.mouseMoveHandler), document.addEventListener("mouseup", _this.mouseUpHandler), 
                e.preventDefault();
            }, _this.mouseUpHandler = function(e) {
                _this.props.onResizeEnd(e.screenX - _this.state.startScreenX), document.removeEventListener("mousemove", _this.mouseMoveHandler), 
                document.removeEventListener("mouseup", _this.mouseUpHandler);
            }, _this.mouseMoveHandler = function(e) {
                _this.props.onResize(e.screenX - _this.state.startScreenX);
            }, _this.state = {
                startScreenX: 0
            }, _this;
        }
        return (0, _inherits3.default)(Resizer, _PureComponent), (0, _createClass3.default)(Resizer, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: _Resizer2.default.resizer,
                    onMouseDown: this.mouseDownHandler
                });
            }
        } ]), Resizer;
    }(_react.PureComponent);
    Resizer.propTypes = {
        onResizeStart: _react.PropTypes.func,
        onResize: _react.PropTypes.func,
        onResizeEnd: _react.PropTypes.func
    }, Resizer.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeEnd: function() {}
    }, exports.default = Resizer;
}, /* 48 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(49);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 49 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._2TwYsTzrpaJZ18Rlnylmtc{height:100%;width:12px;position:relative;left:-6px;cursor:col-resize}._2TwYsTzrpaJZ18Rlnylmtc:hover:before{background:#2684ff}._2TwYsTzrpaJZ18Rlnylmtc:before{content:'';width:2px;height:100%;position:absolute;left:5px}", "" ]), 
    // exports
    exports.locals = {
        resizer: "_2TwYsTzrpaJZ18Rlnylmtc",
        resizer: "_2TwYsTzrpaJZ18Rlnylmtc"
    };
}, /* 50 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getContainerWidth(navigationWidth) {
        return navigationWidth > _sharedVariables.collapseBreakpoint ? navigationWidth - _sharedVariables.globalOpenWidth : Math.max(0, _sharedVariables.containerClosedWidth);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = getContainerWidth;
    var _sharedVariables = __webpack_require__(24);
}, /* 51 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _ContainerItem = __webpack_require__(52), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _DefaultLinkComponent = __webpack_require__(34), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _NavigationItem = __webpack_require__(54), _NavigationItem2 = _interopRequireDefault(_NavigationItem), ContainerItem = function(_PureComponent) {
        function ContainerItem() {
            return (0, _classCallCheck3.default)(this, ContainerItem), (0, _possibleConstructorReturn3.default)(this, (ContainerItem.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerItem)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerItem, _PureComponent), (0, _createClass3.default)(ContainerItem, [ {
            key: "render",
            value: function() {
                var _className;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_ContainerItem.containerItem, (_className = {}, 
                    (0, _defineProperty3.default)(_className, _ContainerItem.hasGlobalAppearance, "global" === this.props.appearance), 
                    (0, _defineProperty3.default)(_className, _ContainerItem.isSelected, this.props.isSelected), 
                    _className))
                }, _react2.default.createElement(_NavigationItem2.default, {
                    action: this.props.action,
                    href: this.props.href,
                    icon: this.props.icon,
                    isCompact: this.props.isCompact,
                    isSelected: this.props.isSelected,
                    linkComponent: this.props.linkComponent,
                    text: this.props.text,
                    textAfter: this.props.textAfter
                }));
            }
        } ]), ContainerItem;
    }(_react.PureComponent);
    ContainerItem.propTypes = {
        appearance: _react.PropTypes.string,
        icon: _react.PropTypes.node,
        isCompact: _react.PropTypes.bool,
        isSelected: _react.PropTypes.bool,
        text: _react.PropTypes.node,
        textAfter: _react.PropTypes.node,
        action: _react.PropTypes.node,
        href: _react.PropTypes.string,
        linkComponent: _react.PropTypes.func
    }, ContainerItem.defaultProps = {
        isCompact: !1,
        isSelected: !1,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = ContainerItem;
}, /* 52 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(53);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 53 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, ".aIpSONUrW63oyoHErO2ff{border-radius:3px}.aIpSONUrW63oyoHErO2ff._2A6VbLN-aeV-cFDanp7CSD,.aIpSONUrW63oyoHErO2ff:hover{background:rgba(9,30,66,.04)}.aIpSONUrW63oyoHErO2ff._2A6VbLN-aeV-cFDanp7CSD._3H0EFslubJxHUc2sOtErnh,.aIpSONUrW63oyoHErO2ff:hover._3H0EFslubJxHUc2sOtErnh{color:#fff;background:rgba(9,30,66,.25)}._2A6VbLN-aeV-cFDanp7CSD{color:#0052cc}", "" ]), 
    // exports
    exports.locals = {
        containerItem: "aIpSONUrW63oyoHErO2ff",
        containerItem: "aIpSONUrW63oyoHErO2ff",
        isSelected: "_2A6VbLN-aeV-cFDanp7CSD",
        isSelected: "_2A6VbLN-aeV-cFDanp7CSD",
        hasGlobalAppearance: "_3H0EFslubJxHUc2sOtErnh",
        hasGlobalAppearance: "_3H0EFslubJxHUc2sOtErnh"
    };
}, /* 54 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _NavigationItem = __webpack_require__(55), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _DefaultLinkComponent = __webpack_require__(34), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), NavigationItem = function(_PureComponent) {
        function NavigationItem() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, NavigationItem);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = NavigationItem.__proto__ || (0, 
            _getPrototypeOf2.default)(NavigationItem)).call.apply(_ref, [ this ].concat(args))), 
            _this.onMouseDown = function(e) {
                e.preventDefault();
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(NavigationItem, _PureComponent), (0, _createClass3.default)(NavigationItem, [ {
            key: "render",
            value: function() {
                var _className, _this2 = this, Link = this.props.linkComponent, Icon = function() {
                    return _this2.props.icon ? _react2.default.createElement("div", {
                        className: _NavigationItem.icon
                    }, _this2.props.icon) : null;
                }, TextAfter = function() {
                    return _this2.props.textAfter ? _react2.default.createElement("div", {
                        className: _NavigationItem.textAfter
                    }, _this2.props.textAfter) : null;
                }, Action = function() {
                    return _this2.props.action ? _react2.default.createElement("div", {
                        className: _NavigationItem.action
                    }, _this2.props.action) : null;
                }, After = function(_ref2) {
                    var children = _ref2.children;
                    return TextAfter || Action ? _react2.default.createElement("div", {
                        className: _NavigationItem.after
                    }, children) : null;
                };
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_NavigationItem.navigationItemOuter, (_className = {}, 
                    (0, _defineProperty3.default)(_className, _NavigationItem.isSelected, this.props.isSelected), 
                    (0, _defineProperty3.default)(_className, _NavigationItem.isCompact, this.props.isCompact), 
                    _className))
                }, _react2.default.createElement(Link, {
                    className: _NavigationItem.link,
                    href: this.props.href,
                    onMouseDown: this.onMouseDown
                }, _react2.default.createElement("div", {
                    className: _NavigationItem.navigationItemInner
                }, _react2.default.createElement(Icon, null), _react2.default.createElement("div", {
                    className: _NavigationItem.text
                }, this.props.text), _react2.default.createElement(After, null, _react2.default.createElement(TextAfter, null)))), _react2.default.createElement(Action, null));
            }
        } ]), NavigationItem;
    }(_react.PureComponent);
    NavigationItem.propTypes = {
        icon: _react.PropTypes.node,
        isCompact: _react.PropTypes.bool,
        isSelected: _react.PropTypes.bool,
        text: _react.PropTypes.node,
        textAfter: _react.PropTypes.node,
        action: _react.PropTypes.node,
        href: _react.PropTypes.string,
        linkComponent: _react.PropTypes.func
    }, NavigationItem.defaultProps = {
        isCompact: !1,
        isSelected: !1,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = NavigationItem;
}, /* 55 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(56);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 56 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._1OSwy-cWdQbp_MwwF2BS7F{width:100%;height:40px;box-sizing:border-box;text-overflow:ellipsis;position:relative}._1OSwy-cWdQbp_MwwF2BS7F ._3SqhxDA-RNIKmQUJOeKm5D{padding:0}._1OSwy-cWdQbp_MwwF2BS7F:hover{padding:2px 0}._1OSwy-cWdQbp_MwwF2BS7F:hover._3SqhxDA-RNIKmQUJOeKm5D{padding:0}._3sK7w-xYlRAdZ4IkvmHXx5 ._1v0MKIYlXxUNtJRAtuOKag{padding-left:0;padding-right:8px}._2kCga5UeVouHtoO6gRaEqP{height:100%;width:100%;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;padding:0 8px;box-sizing:border-box}._3sK7w-xYlRAdZ4IkvmHXx5{height:36px}._1AgJeH9_X62LKMYIb7wJ__:focus{display:block;height:100%;border-radius:3px}._1AgJeH9_X62LKMYIb7wJ__:focus:focus{outline:none;box-shadow:0 0 0 2px #4c9aff}._3r7qom-yRzHwHDkqIRGtSj{display:-webkit-box;display:flex;height:100%;-webkit-box-pack:center;justify-content:center;position:absolute;right:8px;top:0}[data-__ak-navigation-container-closed=true] ._3r7qom-yRzHwHDkqIRGtSj{opacity:0}._1v0MKIYlXxUNtJRAtuOKag{-webkit-transition:padding .2s;transition:padding .2s;padding:0 24px 0 14px;display:-webkit-box;display:flex}[data-__ak-navigation-container-closed=true] ._1v0MKIYlXxUNtJRAtuOKag{padding:0 6px}._1v0MKIYlXxUNtJRAtuOKag>*{width:20px;height:20px}._18sB1xZDXQ_yoIDWXyIu60{min-width:24px}.OL2QbuKfAZmjDCygonDXg{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;-webkit-box-flex:1;flex-grow:1}[data-__ak-navigation-container-closed=true] .OL2QbuKfAZmjDCygonDXg{opacity:0}.OL2QbuKfAZmjDCygonDXg.h1UhYsSPSBY259isEuTPo{margin-right:24px}._1sMcXD5-tnTyaWxJEnbnWT{position:relative;z-index:1}[data-__ak-navigation-container-closed=true] ._1sMcXD5-tnTyaWxJEnbnWT{opacity:0}", "" ]), 
    // exports
    exports.locals = {
        navigationItemOuter: "_1OSwy-cWdQbp_MwwF2BS7F",
        navigationItemOuter: "_1OSwy-cWdQbp_MwwF2BS7F",
        isSelected: "_3SqhxDA-RNIKmQUJOeKm5D",
        isSelected: "_3SqhxDA-RNIKmQUJOeKm5D",
        isCompact: "_3sK7w-xYlRAdZ4IkvmHXx5",
        isCompact: "_3sK7w-xYlRAdZ4IkvmHXx5",
        icon: "_1v0MKIYlXxUNtJRAtuOKag",
        icon: "_1v0MKIYlXxUNtJRAtuOKag",
        navigationItemInner: "_2kCga5UeVouHtoO6gRaEqP",
        navigationItemInner: "_2kCga5UeVouHtoO6gRaEqP",
        link: "_1AgJeH9_X62LKMYIb7wJ__",
        link: "_1AgJeH9_X62LKMYIb7wJ__",
        action: "_3r7qom-yRzHwHDkqIRGtSj",
        action: "_3r7qom-yRzHwHDkqIRGtSj",
        after: "_18sB1xZDXQ_yoIDWXyIu60",
        after: "_18sB1xZDXQ_yoIDWXyIu60",
        text: "OL2QbuKfAZmjDCygonDXg",
        text: "OL2QbuKfAZmjDCygonDXg",
        hasTextAfterOrAction: "h1UhYsSPSBY259isEuTPo",
        hasTextAfterOrAction: "h1UhYsSPSBY259isEuTPo",
        textAfter: "_1sMcXD5-tnTyaWxJEnbnWT",
        textAfter: "_1sMcXD5-tnTyaWxJEnbnWT"
    };
}, /* 57 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(20), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _ContainerItemGroup = __webpack_require__(58), _ContainerItemGroup2 = _interopRequireDefault(_ContainerItemGroup), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), ContainerItemGroup = function(_PureComponent) {
        function ContainerItemGroup() {
            return (0, _classCallCheck3.default)(this, ContainerItemGroup), (0, _possibleConstructorReturn3.default)(this, (ContainerItemGroup.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerItemGroup)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerItemGroup, _PureComponent), (0, _createClass3.default)(ContainerItemGroup, [ {
            key: "render",
            value: function() {
                var _props = this.props, title = _props.title, action = _props.action, Title = function() {
                    return title ? _react2.default.createElement("div", {
                        className: _ContainerItemGroup2.default.title
                    }, _react2.default.createElement("span", null, title)) : null;
                };
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _ContainerItemGroup2.default.noHeaderContent, !(title || action)))
                }, title || action ? _react2.default.createElement("div", {
                    className: _ContainerItemGroup2.default.header
                }, _react2.default.createElement(Title, null), this.props.action ? _react2.default.createElement("div", {
                    className: _ContainerItemGroup2.default.action
                }, this.props.action) : null) : null, _react2.default.createElement("div", null, this.props.children));
            }
        } ]), ContainerItemGroup;
    }(_react.PureComponent);
    ContainerItemGroup.propTypes = {
        action: _react.PropTypes.node,
        children: _react.PropTypes.node,
        title: _react.PropTypes.string
    }, exports.default = ContainerItemGroup;
}, /* 58 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(59);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 59 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._3PdtqSPMRrMDxNxs50aDvM{display:-webkit-box;display:flex;margin-bottom:8px;margin-left:8px;margin-top:16px}[data-__ak-navigation-container-closed=true] ._3PdtqSPMRrMDxNxs50aDvM{margin-left:4px;margin-right:4px;border-top:1px solid rgba(9,30,66,.13)}[data-__ak-navigation-container-closed=true] ._3PdtqSPMRrMDxNxs50aDvM ._1VmQfIfOIeIOec-OUKKDbD,[data-__ak-navigation-container-closed=true] ._3PdtqSPMRrMDxNxs50aDvM ._3IKOfZdGh0va_9wwmYqlwR{visibility:hidden}._1-NbHAc6FQKduXlTIev5P_{margin-top:24px}._1VmQfIfOIeIOec-OUKKDbD{align-self:center;color:#8993a4;display:-webkit-box;display:flex;-webkit-box-flex:1;flex-grow:1;font-size:12px;text-transform:uppercase}._3IKOfZdGh0va_9wwmYqlwR{margin-right:8px}", "" ]), 
    // exports
    exports.locals = {
        header: "_3PdtqSPMRrMDxNxs50aDvM",
        header: "_3PdtqSPMRrMDxNxs50aDvM",
        title: "_1VmQfIfOIeIOec-OUKKDbD",
        title: "_1VmQfIfOIeIOec-OUKKDbD",
        action: "_3IKOfZdGh0va_9wwmYqlwR",
        action: "_3IKOfZdGh0va_9wwmYqlwR",
        noHeaderContent: "_1-NbHAc6FQKduXlTIev5P_",
        noHeaderContent: "_1-NbHAc6FQKduXlTIev5P_"
    };
}, /* 60 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _ContainerHeader = __webpack_require__(61), _ContainerHeader2 = _interopRequireDefault(_ContainerHeader), _DefaultLinkComponent = __webpack_require__(34), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), ContainerHeader = function(_PureComponent) {
        function ContainerHeader() {
            return (0, _classCallCheck3.default)(this, ContainerHeader), (0, _possibleConstructorReturn3.default)(this, (ContainerHeader.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerHeader)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerHeader, _PureComponent), (0, _createClass3.default)(ContainerHeader, [ {
            key: "render",
            value: function() {
                var _props = this.props, href = _props.href, text = _props.text, Link = _props.linkComponent;
                return _react2.default.createElement("div", {
                    className: _ContainerHeader2.default.containerHeaderWrapper
                }, _react2.default.createElement(Link, {
                    className: _ContainerHeader2.default.link,
                    href: href
                }, _react2.default.createElement("div", {
                    className: _ContainerHeader2.default.containerHeader
                }, _react2.default.createElement("div", {
                    className: _ContainerHeader2.default.icon
                }, this.props.icon), _react2.default.createElement("div", {
                    className: _ContainerHeader2.default.text
                }, " ", text, " "))));
            }
        } ]), ContainerHeader;
    }(_react.PureComponent);
    ContainerHeader.propTypes = {
        icon: _react.PropTypes.node,
        text: _react.PropTypes.string,
        href: _react.PropTypes.string,
        linkComponent: _react.PropTypes.func
    }, ContainerHeader.defaultProps = {
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = ContainerHeader;
}, /* 61 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(62);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 62 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._1AJfZCtQdYjFiFsd3EPQGQ{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;align-content:center}._298SAqvdBUh5KER7_Ysx6s{-webkit-transition:padding .2s;transition:padding .2s;padding:4px 14px 0 12px;margin-bottom:12px}[data-__ak-navigation-container-closed=true] ._298SAqvdBUh5KER7_Ysx6s{padding:4px 20px 0 4px}.t8yIHZXfNODuT7WdVTJj3{color:#505f79;text-decoration:none;font-weight:500}.t8yIHZXfNODuT7WdVTJj3:hover{color:#505f79;text-decoration:none}.ysvqDhBYm_rh0nNncLddB>*{width:40px;height:40px;border-radius:4px}._2CxxTGBwpWj_84bAsb-fnq{margin-left:16px}", "" ]), 
    // exports
    exports.locals = {
        containerHeader: "_1AJfZCtQdYjFiFsd3EPQGQ",
        containerHeader: "_1AJfZCtQdYjFiFsd3EPQGQ",
        containerHeaderWrapper: "_298SAqvdBUh5KER7_Ysx6s",
        containerHeaderWrapper: "_298SAqvdBUh5KER7_Ysx6s",
        link: "t8yIHZXfNODuT7WdVTJj3",
        link: "t8yIHZXfNODuT7WdVTJj3",
        icon: "ysvqDhBYm_rh0nNncLddB",
        icon: "ysvqDhBYm_rh0nNncLddB",
        text: "_2CxxTGBwpWj_84bAsb-fnq",
        text: "_2CxxTGBwpWj_84bAsb-fnq"
    };
}, /* 63 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _ContainerLogo = __webpack_require__(64), _ContainerLogo2 = _interopRequireDefault(_ContainerLogo), ContainerLogo = function(_PureComponent) {
        function ContainerLogo() {
            return (0, _classCallCheck3.default)(this, ContainerLogo), (0, _possibleConstructorReturn3.default)(this, (ContainerLogo.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerLogo)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerLogo, _PureComponent), (0, _createClass3.default)(ContainerLogo, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: _ContainerLogo2.default.containerLogo
                }, this.props.children);
            }
        } ]), ContainerLogo;
    }(_react.PureComponent);
    ContainerLogo.propTypes = {
        children: _react.PropTypes.node
    }, exports.default = ContainerLogo;
}, /* 64 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(65);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 65 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._3FSM_NyupZY_4QOuNvS0G0{height:24px;margin:28px 0 28px 24px}", "" ]), 
    // exports
    exports.locals = {
        containerLogo: "_3FSM_NyupZY_4QOuNvS0G0",
        containerLogo: "_3FSM_NyupZY_4QOuNvS0G0"
    };
}, /* 66 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _ContainerNavigationNested = __webpack_require__(67), _ContainerNavigationNested2 = _interopRequireDefault(_ContainerNavigationNested), ContainerNavigationNested = function(_PureComponent) {
        function ContainerNavigationNested(props) {
            (0, _classCallCheck3.default)(this, ContainerNavigationNested);
            var _this = (0, _possibleConstructorReturn3.default)(this, (ContainerNavigationNested.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerNavigationNested)).call(this, props));
            return _this.state = {}, _this;
        }
        return (0, _inherits3.default)(ContainerNavigationNested, _PureComponent), (0, _createClass3.default)(ContainerNavigationNested, [ {
            key: "componentDidMount",
            value: function() {
                var _this2 = this;
                this.animationEndHandler = function() {
                    "left" === _this2.props.animationDirection ? (_this2.animateContainer.classList.remove(_ContainerNavigationNested2.default.containerNavigationNestedLeftAnimate), 
                    _this2.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedLeftAnimateEnd)) : (_this2.animateContainer.classList.remove(_ContainerNavigationNested2.default.containerNavigationNestedRightAnimate), 
                    _this2.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedRightAnimateEnd));
                }, this.animateContainer.addEventListener("animationend", this.animationEndHandler);
            }
        }, {
            key: "componentWillUpdate",
            value: function(nextProps) {
                nextProps.children !== this.props.children && this.setState({
                    prevChildren: this.props.children
                });
            }
        }, {
            key: "componentDidUpdate",
            value: function() {
                this.animateContainer.className = _ContainerNavigationNested2.default.containerNavigationNested, 
                // handle left animation
                "left" === this.props.animationDirection && this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedLeftAnimate), 
                // handle right animation
                "right" === this.props.animationDirection && this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedRightAnimate);
            }
        }, {
            key: "componentWillUnmount",
            value: function() {
                this.animateContainer.removeEventListener("animationend", this.animationEndHandler);
            }
        }, {
            key: "render",
            value: function() {
                var _this3 = this, children = this.props.children, prevChildren = this.state.prevChildren, activePane = _react2.default.createElement("div", {
                    key: "active-pane",
                    className: _ContainerNavigationNested2.default.pageWrapper
                }, children), prevPane = _react2.default.createElement("div", {
                    key: "prev-pane",
                    className: _ContainerNavigationNested2.default.pageWrapper
                }, prevChildren), content = "left" === this.props.animationDirection ? [ prevPane, activePane ] : [ activePane, prevPane ];
                return _react2.default.createElement("div", {
                    className: _ContainerNavigationNested2.default.containerNavigationNested,
                    ref: function(el) {
                        _this3.animateContainer = el;
                    }
                }, content);
            }
        } ]), ContainerNavigationNested;
    }(_react.PureComponent);
    ContainerNavigationNested.propTypes = {
        children: _react.PropTypes.node,
        animationDirection: _react.PropTypes.oneOf([ "left", "right" ])
    }, exports.default = ContainerNavigationNested;
}, /* 67 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(68);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 68 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, "._2k3eUFkgmCrDsvV75JaYzT{display:-webkit-box;display:flex;position:relative}._2Hb4iB9yUWrl2dD2m7_MfO{-webkit-animation-name:_3myiETqeGvVx2eHK5A9ScH;animation-name:_3myiETqeGvVx2eHK5A9ScH;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}._2hY4ITShgroDTFHNgXKWES{-webkit-transform:translateX(-100%);transform:translateX(-100%)}@-webkit-keyframes _3myiETqeGvVx2eHK5A9ScH{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}@keyframes _3myiETqeGvVx2eHK5A9ScH{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}.LKjnRHS6bXAZ3_nV3w1gH{-webkit-animation-name:_3XurBbDkQt_XnwP6bYKoZl;animation-name:_3XurBbDkQt_XnwP6bYKoZl;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}._1NI3RQJKZwPHPJQ8p0P5mf{-webkit-transform:translateX(0);transform:translateX(0)}@-webkit-keyframes _3XurBbDkQt_XnwP6bYKoZl{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes _3XurBbDkQt_XnwP6bYKoZl{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(0);transform:translateX(0)}}._125bZvMG8qcQal80oSyzbP{-webkit-box-flex:1;flex:1 0 100%;overflow:hidden;box-sizing:border-box;padding:0 8px}", "" ]), 
    // exports
    exports.locals = {
        containerNavigationNested: "_2k3eUFkgmCrDsvV75JaYzT",
        containerNavigationNested: "_2k3eUFkgmCrDsvV75JaYzT",
        containerNavigationNestedLeftAnimate: "_2Hb4iB9yUWrl2dD2m7_MfO",
        containerNavigationNestedLeftAnimate: "_2Hb4iB9yUWrl2dD2m7_MfO",
        slideLeft: "_3myiETqeGvVx2eHK5A9ScH",
        slideLeft: "_3myiETqeGvVx2eHK5A9ScH",
        containerNavigationNestedLeftAnimateEnd: "_2hY4ITShgroDTFHNgXKWES",
        containerNavigationNestedLeftAnimateEnd: "_2hY4ITShgroDTFHNgXKWES",
        containerNavigationNestedRightAnimate: "LKjnRHS6bXAZ3_nV3w1gH",
        containerNavigationNestedRightAnimate: "LKjnRHS6bXAZ3_nV3w1gH",
        slideRight: "_3XurBbDkQt_XnwP6bYKoZl",
        slideRight: "_3XurBbDkQt_XnwP6bYKoZl",
        containerNavigationNestedRightAnimateEnd: "_1NI3RQJKZwPHPJQ8p0P5mf",
        containerNavigationNestedRightAnimateEnd: "_1NI3RQJKZwPHPJQ8p0P5mf",
        pageWrapper: "_125bZvMG8qcQal80oSyzbP",
        pageWrapper: "_125bZvMG8qcQal80oSyzbP"
    };
}, /* 69 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _DrawerItem = __webpack_require__(70), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _DefaultLinkComponent = __webpack_require__(34), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _NavigationItem = __webpack_require__(54), _NavigationItem2 = _interopRequireDefault(_NavigationItem), DrawerItem = function(_PureComponent) {
        function DrawerItem() {
            return (0, _classCallCheck3.default)(this, DrawerItem), (0, _possibleConstructorReturn3.default)(this, (DrawerItem.__proto__ || (0, 
            _getPrototypeOf2.default)(DrawerItem)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DrawerItem, _PureComponent), (0, _createClass3.default)(DrawerItem, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_DrawerItem.drawerItem)
                }, _react2.default.createElement(_NavigationItem2.default, {
                    action: this.props.action,
                    href: this.props.href,
                    icon: this.props.icon,
                    isCompact: this.props.isCompact,
                    linkComponent: this.props.linkComponent,
                    text: this.props.text,
                    textAfter: this.props.textAfter
                }));
            }
        } ]), DrawerItem;
    }(_react.PureComponent);
    DrawerItem.propTypes = {
        icon: _react.PropTypes.node,
        isCompact: _react.PropTypes.bool,
        text: _react.PropTypes.node,
        textAfter: _react.PropTypes.node,
        action: _react.PropTypes.node,
        href: _react.PropTypes.string,
        linkComponent: _react.PropTypes.func
    }, DrawerItem.defaultProps = {
        isCompact: !1,
        isSelected: !1,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = DrawerItem;
}, /* 70 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(71);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(18)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 71 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(17)(), // imports
    // module
    exports.push([ module.id, ".ZdTHJhaIdp6UC_lUn2d34{color:#42526e;border-radius:3px}.ZdTHJhaIdp6UC_lUn2d34:hover{background:rgba(9,30,66,.04)}.ZdTHJhaIdp6UC_lUn2d34:active{background:#deebff;color:#0052cc}", "" ]), 
    // exports
    exports.locals = {
        drawerItem: "ZdTHJhaIdp6UC_lUn2d34",
        drawerItem: "ZdTHJhaIdp6UC_lUn2d34"
    };
} ]);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/ak-navigation/dist/bundle-cjs.js
// module id = 340
// module chunks = 0